import { LineArrowCircleDown } from '@qr-front/icons/line-arrow-circle-down'
import { LineArrowCircleUp } from '@qr-front/icons/line-arrow-circle-up'
import { motion } from 'motion/react'

type TSortDialogListItemProps = {
	index: number
	name: string
	itemsLength: number
	onSortChange: (index: number, direction: 'up' | 'down') => void
}

export const SortDialogListItem = ({
	index,
	name,
	itemsLength,
	onSortChange,
}: TSortDialogListItemProps) => {
	const isFirst = index === 0
	const isLast = index === itemsLength - 1

	return (
		<motion.li
			className="flex h-14 items-center gap-4 rounded-8 border border-solid border-border-grey-50 bg-white p-4"
			layout="preserve-aspect"
			initial={{ opacity: 0, y: -20, scale: 1.2 }}
			animate={{ opacity: 1, y: 0, scale: 1 }}
			transition={{
				duration: 0.3,
				type: 'spring',
				damping: 20,
				stiffness: 300,
			}}
		>
			<div className="flex w-full items-center justify-between gap-2">
				<span className="type-body-small truncate font-semibold text-black">
					{name}
				</span>

				<div className="flex shrink-0 items-center gap-4">
					<div className="h-0 w-6 rotate-90 border border-solid border-border-grey-50" />
					<div className="flex items-center gap-2">
						<LineArrowCircleUp
							className={isFirst ? 'text-border-grey-50' : 'cursor-pointer'}
							onClick={() => onSortChange(index, 'up')}
						/>
						<LineArrowCircleDown
							className={isLast ? 'text-border-grey-50' : 'cursor-pointer'}
							onClick={() => onSortChange(index, 'down')}
						/>
					</div>
				</div>
			</div>
		</motion.li>
	)
}
